import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { formatPhone } from 'utils/formatting';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export default function BeautyCtn({ ctn, onReset, className }) {
  return (
    <div className={cx('component', className)}>
      {formatPhone(ctn, '+7 ___ ___-__-__')}
      {onReset ?
        <button className={cx('reset')} onClick={onReset} name="Сбросить" type="button">
          ✕
        </button>
      : null}
    </div>
  );
}

BeautyCtn.propTypes = {
  ctn: PropTypes.string.isRequired,
  onReset: PropTypes.func,
  className: PropTypes.string,
};
